import { Input } from 'antd'
import { Form } from 'antd'
import { FC } from 'react'

interface ImageLinkProps {}

const ImageLink: FC<ImageLinkProps> = () => {
    const name = 'imageLink'

    return (
        <Form.Item name={name} label={'Ссылка на превью'}>
            <Input />
        </Form.Item>
    )
}

export default ImageLink
